import { useEffect, useState } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { App, Button } from 'antd';
import { AxiosError } from 'axios';
import { delay } from 'lodash';

import { useStartPullDmsTickets } from '../data/dms-tickets';

export type StartPullDmsTicketsButtonProps = {
  onReload?: () => void;
};

export const StartPullDmsTicketsButton = ({ onReload }: StartPullDmsTicketsButtonProps) => {
  const [retryDelay, setRetryDelay] = useState(false);
  const { notification } = App.useApp();
  const triggerPull = useStartPullDmsTickets();

  useEffect(() => {
    if (triggerPull.isSuccess) {
      notification.success({
        message: 'DMS Ticket Pull Started',
        description: 'Repull was successful started. Note that it can take several minutes to complete.',
      });
    }

    if (triggerPull.isError) {
      const error = triggerPull.error as AxiosError;

      notification.error({
        message: 'Repull Error, please try again.',
        description: error.message,
        duration: 0, // force user to close
      });
    }
  }, [notification, triggerPull.error, triggerPull.isError, triggerPull.isSuccess]);

  return (
    <Button
      icon={<ReloadOutlined />}
      title="Click this to pull the latest dms tickets into SAAF. Note that this happens automatically every 30 minutes."
      onClick={() => {
        setRetryDelay(true);
        delay(() => {
          triggerPull.mutate(undefined, { onSettled: () => onReload && onReload() });
          setRetryDelay(false);
        }, 800);
      }}
      loading={retryDelay || triggerPull.isPending}
    >
      Repull DMS Tickets
    </Button>
  );
};
